import { useMutation } from '@tanstack/react-query'

import { create } from 'services/order-redemtions'

export function useCreateOrderRedemption() {
  return useMutation(create)
}
